// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/fenced-imports */
import { Option } from "@insite/client-framework/Types/FieldDefinition";
import Select from "@insite/mobius/Select";
import StandardControl from "@insite/shell-public/Components/StandardControl";
import { CustomEditorTemplateProps, SelectOverlapItemTemplateDefinition } from "@turnerBlueprint/CustomFieldDefinition";
import * as React from "react";

interface State {
    options?: Option<string>[];
}

type Props = CustomEditorTemplateProps<string, SelectOverlapItemTemplateDefinition>;

class SelectOverlapItemField extends React.Component<Props, State> {
    componentDidMount() {
        this.getOptions();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.item.fields?.["columns"] !== this.props.item.fields?.["columns"]) {
            this.getOptions();
        }
    }

    getOptions = () => {
        const columns = this.props.item.fields?.["columns"] || [];
        if (!columns || columns.length === 0) {
            this.setState({
                options: [],
            });
        }

        const numOfItems: Option<string>[] = Array.from({ length: columns.length }, (_, i) => ({
            displayName: `${i + 1}`,
            value: `${i + 1}`,
        }));

        this.setState({
            options: [...numOfItems],
        });
    };

    onChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.props.updateField(this.props.fieldDefinition.name, event.currentTarget.value);
    };

    render() {
        // There is no clean way to get typing to work properly for StandardControl, so just bypass it with as any
        return (
            <StandardControl fieldDefinition={this.props.fieldDefinition as any}>
                <Select
                    uid={this.props.fieldDefinition.name}
                    value={this.props.fieldValue}
                    onChange={this.onChange}
                    disabled={
                        this.props.fieldDefinition.isEnabled && !this.props.fieldDefinition.isEnabled(this.props.item)
                    }
                >
                    {!this.props.fieldDefinition.hideEmptyOption && <option value="">Select Value</option>}
                    {!this.props.fieldDefinition.hideAllOption && <option value="all">All</option>}
                    {this.state?.options?.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayName ?? option.value}
                        </option>
                    ))}
                </Select>
            </StandardControl>
        );
    }
}

export default SelectOverlapItemField;
